import { render } from "./DataTable.vue?vue&type=template&id=dd50aaf0"
import script from "./DataTable.vue?vue&type=script&lang=js"
export * from "./DataTable.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/DataTable/DataTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dd50aaf0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dd50aaf0', __exports__)) {
    console.log('reload')
    api.reload('dd50aaf0', __exports__)
  }
  
  module.hot.accept("./DataTable.vue?vue&type=template&id=dd50aaf0", () => {
    console.log('re-render')
    api.rerender('dd50aaf0', render)
  })

}


export default __exports__